import React from 'react'
import { Text } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { Button } from '../ui/Button'
import type { TimeExpiredNotice } from '../../lib/aiTakeoverNotice'

/** Shown in place of the game when the viewer's seat was handed to an AI. Nothing here acts on the game. */
export function TimeExpiredScreen({ notice, onBack }: { notice: TimeExpiredNotice; onBack: () => void }) {
  const abandoned = notice.reason === 'abandoned'
  return (
    <SafeAreaView className="flex-1 bg-canvas items-center justify-center gap-5 px-8" testID="time-expired-screen">
      <Text style={{ fontSize: 44 }} accessibilityElementsHidden>
        {abandoned ? '🚪' : '⏰'}
      </Text>
      <Text className="text-ink text-lg font-stencil uppercase text-center" accessibilityRole="header">
        {abandoned ? 'You abandoned this game' : "Time's up"}
      </Text>
      <Text className="text-ink-soft font-typed text-sm text-center">
        {abandoned
          ? `${notice.botName ?? 'An AI'} has taken over your seat in ${notice.gameName ?? 'this game'} for the rest of the game.`
          : `Your time expired in ${notice.gameName ?? 'this game'}. ${notice.botName ?? 'An AI'} has taken over your seat for the rest of the game.`}
      </Text>
      <Button title="Back to lobby" variant="secondary" onPress={onBack} accessibilityLabel="Back to lobby" />
    </SafeAreaView>
  )
}
